(function () {
    'use strict';

    angular
        .module('app')
        .controller('SelectCampaignController', SelectCampaignController);

    SelectCampaignController.$inject = ['debug', 'API', 'i18n', '$scope',];

    function SelectCampaignController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.loading = false;
        vm.campaignsList = [];
        vm.newCampaign = null;

        activate();

        function activate() {
            loadCampaigns();
            vm.campaign = $scope.placeholders.campaign;
        }

        function submit() {
            if (vm.newCampaign) {
                $scope.$parent.submit(vm.newCampaign);
            }
        }

        function loadCampaigns() {
            vm.loading = true;
            API.Campaign.search({
                'per-page': 0,
                'sort': 'name',
                'fields': 'id,name'
            })
                .$promise
                .then(function (list) {
                    angular.forEach(list.items, function (campaign) {
                        if (!vm.campaign || campaign.id !== vm.campaign.id) {
                            vm.campaignsList.push({
                                value: campaign.id,
                                label: campaign.name,
                            });
                        }
                    });
                }, function () {
                    debug.error('Could not load campaigns.');
                }).finally(function () {
                vm.loading = false;
            });
        }
    }
})();